// Contact Management
const GetCountryStates = "Common/GetCountryStates"

// User Controller
const ImpersonateUser = "User/ImpersonateUser"
const CreateNewUser = "User/CreateCmUser"
const GetUserDetailsById = "User/GetUserDetailsById"
const UpdateUser = "User/UpdateUser"
const GetAllUsers = "User/GetUsers"
const GetUserByEmail = "User/GetUserByEmail"
const GetUserDetailsbyEmail = "User/GetUserDetailsbyEmail"
const InviteUser = "User/InviteUser"

// User Role Mapping Controller
const GetAllRoles = "UserRoleMapping/GetAllRoles"
const GetUserRoles = "User/GetUserRoles"
const SaveUserRoles = "UserRoleMapping/SaveUserRoles"

// User Company Mapping Controller
const ImportCompany = "UserCompanyMapping/ImportCompany"
const CreateCompanyUserMapping = "UserCompanyMapping/CreateCompanyUserMapping"
const CreateUserCompanyMapping = "UserCompanyMapping/CreateUserCompanyMapping"
const UpdateUserCompanyMappingById = "UserCompanyMapping/UpdateUserCompanyMapping"
const GetUsersBySharedCompanies = "User/GetUsersBySharedCompanies"

// Company Controller
const GetActiveCompanies = "Company/GetCompanies"
const GetCompanyDetailsById = "Company/GetCompanyDetailsById"
const UpateCompany = "Company/UpdateCompany"
const GetAgentDetails = "Company/GetAgentDetails"
const GetUserCompanies = "Company/GetUserCompanies"

// Address Controller
const UpdateUserAddress = "Address/UpdateAddress"
const CreateAddress = "Address/CreateAddress"

// Vessel Controller
const GetVessels = "Vessel/GetVessels"
const GetVesselDetailsById = "Vessel/GetVesselDetailsById"
const UpdateVessel = "Vessel/UpdateVessel"
const UpdateVesselUserMapping = "Vessel/UpdateVesselUserMapping"
const CreateUserVesselMapping = "Vessel/CreateUserVesselMapping"
const CreateVessel = "Vessel/CreateVessel"

// Dashboard Controller
const UnlistedUser = "Dashboard/SendVerificationEmail"


export const ApiUrls = {
  // Common
  GetCountryStates,

  // User
  ImpersonateUser,
  CreateNewUser,
  GetUserDetailsById,
  UpdateUser,
  GetAllUsers,
  GetUserByEmail,
  GetUserDetailsbyEmail,
  GetUsersBySharedCompanies,
  InviteUser,

  // User Role Mapping
  GetAllRoles,
  GetUserRoles,
  SaveUserRoles,

  // User Company Mapping
  ImportCompany,
  CreateCompanyUserMapping,
  CreateUserCompanyMapping,
  UpdateUserCompanyMappingById,

  // Company
  GetActiveCompanies,
  GetCompanyDetailsById,
  UpateCompany,
  GetUserCompanies,
  GetAgentDetails,

  // Address
  UpdateUserAddress,
  CreateAddress,

  // Vessel
  GetVessels,
  GetVesselDetailsById,
  UpdateVessel,
  UpdateVesselUserMapping,
  CreateUserVesselMapping,
  CreateVessel,

  // Dashboard
  UnlistedUser
}
